// Copyright (c) 2018 Deere & Company

export const environmentIsProd = appConfig => appConfig.sapEnvironments.some(e => e.name === 'PAG');

export const environmentIsReady = appConfig => appConfig.sapEnvironments.length > 0;



// WEBPACK FOOTER //
// ./src/shared/services/environment.js